import styled from 'styled-components';

export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  z-index: 2;
  align-items: center;

  @media screen and (max-width: 960px) {
    padding-top: 0;
    justify-content: initial;
  }
`;

export const Content = styled.div`
  background-color: #fff;
  font-size: 24px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-weight: bold;

  p {
    margin-bottom: 25px;
  }

  @media screen and (max-width: 960px) {
    margin-top: 20px;
    border-radius: 12px 12px 0 0;
    height: fit-content;
    width: 100%;
    z-index: 40;
    padding: 24px 20px;
    bottom: 0;
    position: absolute;
  }
`;
